module.exports = __webpack_public_path__ + "1295d0638034c81115ac3148b77e0a8e.svg";